import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import cbconnectit.portfolio.web.admin.pages.AdminPage as _cbconnectit_portfolio_web_admin_pages_AdminPage
import cbconnectit.portfolio.web.admin.pages.AdminSettingsPage as _cbconnectit_portfolio_web_admin_pages_AdminSettingsPage
import cbconnectit.portfolio.web.admin.pages.LoginPage as _cbconnectit_portfolio_web_admin_pages_LoginPage
import cbconnectit.portfolio.web.admin.pages.companies.AdminCompaniesPage as _cbconnectit_portfolio_web_admin_pages_companies_AdminCompaniesPage
import cbconnectit.portfolio.web.admin.pages.companies.manage.AdminManageCompaniesPage as _cbconnectit_portfolio_web_admin_pages_companies_manage_AdminManageCompaniesPage
import cbconnectit.portfolio.web.admin.pages.experiences.AdminExperiencesPage as _cbconnectit_portfolio_web_admin_pages_experiences_AdminExperiencesPage
import cbconnectit.portfolio.web.admin.pages.experiences.manage.AdminManageExperiencesPage as _cbconnectit_portfolio_web_admin_pages_experiences_manage_AdminManageExperiencesPage
import cbconnectit.portfolio.web.admin.pages.jobpositions.AdminJobPositionsPage as _cbconnectit_portfolio_web_admin_pages_jobpositions_AdminJobPositionsPage
import cbconnectit.portfolio.web.admin.pages.jobpositions.manage.AdminManageJobPositionsPage as _cbconnectit_portfolio_web_admin_pages_jobpositions_manage_AdminManageJobPositionsPage
import cbconnectit.portfolio.web.admin.pages.projects.AdminProjectsPage as _cbconnectit_portfolio_web_admin_pages_projects_AdminProjectsPage
import cbconnectit.portfolio.web.admin.pages.projects.manage.AdminManageProjectsPage as _cbconnectit_portfolio_web_admin_pages_projects_manage_AdminManageProjectsPage
import cbconnectit.portfolio.web.admin.pages.services.AdminServicesPage as _cbconnectit_portfolio_web_admin_pages_services_AdminServicesPage
import cbconnectit.portfolio.web.admin.pages.services.manage.AdminManageServicesPage as _cbconnectit_portfolio_web_admin_pages_services_manage_AdminManageServicesPage
import cbconnectit.portfolio.web.admin.pages.tags.AdminTagsPage as _cbconnectit_portfolio_web_admin_pages_tags_AdminTagsPage
import cbconnectit.portfolio.web.admin.pages.tags.manage.AdminManageTagsPage as _cbconnectit_portfolio_web_admin_pages_tags_manage_AdminManageTagsPage
import cbconnectit.portfolio.web.admin.pages.testimonials.AdminTestimonialsPage as _cbconnectit_portfolio_web_admin_pages_testimonials_AdminTestimonialsPage
import cbconnectit.portfolio.web.admin.pages.testimonials.manage.AdminManageTestimonialsPage as _cbconnectit_portfolio_web_admin_pages_testimonials_manage_AdminManageTestimonialsPage
import cbconnectit.portfolio.web.pages.HomePage as _cbconnectit_portfolio_web_pages_HomePage
import cbconnectit.portfolio.web.pages.projects.ProjectsPage as _cbconnectit_portfolio_web_pages_projects_ProjectsPage
import cbconnectit.portfolio.web.pages.services.ServicesPage as _cbconnectit_portfolio_web_pages_services_ServicesPage
import cbconnectit.portfolio.web.pages.services.service.ServicePage as _cbconnectit_portfolio_web_pages_services_service_ServicePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "Portfolio", "BASE_URL" to "https://cb-connect-it.com"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_pages_HomePage()
        }
        ctx.router.register(
            "/admin",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_AdminPage()
        }
        ctx.router.register(
            "/admin/companies",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_companies_AdminCompaniesPage()
        }
        ctx.router.register(
            "/admin/companies/manage",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_companies_manage_AdminManageCompaniesPage()
        }
        ctx.router.register(
            "/admin/experiences",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_experiences_AdminExperiencesPage()
        }
        ctx.router.register(
            "/admin/experiences/manage",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_experiences_manage_AdminManageExperiencesPage()
        }
        ctx.router.register(
            "/admin/job-positions",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_jobpositions_AdminJobPositionsPage()
        }
        ctx.router.register(
            "/admin/job-positions/manage",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_jobpositions_manage_AdminManageJobPositionsPage()
        }
        ctx.router.register(
            "/admin/login",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_LoginPage()
        }
        ctx.router.register(
            "/admin/projects",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_projects_AdminProjectsPage()
        }
        ctx.router.register(
            "/admin/projects/manage",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_projects_manage_AdminManageProjectsPage()
        }
        ctx.router.register(
            "/admin/services",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_services_AdminServicesPage()
        }
        ctx.router.register(
            "/admin/services/manage",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_services_manage_AdminManageServicesPage()
        }
        ctx.router.register(
            "/admin/settings",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_AdminSettingsPage()
        }
        ctx.router.register(
            "/admin/tags",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_tags_AdminTagsPage()
        }
        ctx.router.register(
            "/admin/tags/manage",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_tags_manage_AdminManageTagsPage()
        }
        ctx.router.register(
            "/admin/testimonials",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_testimonials_AdminTestimonialsPage()
        }
        ctx.router.register(
            "/admin/testimonials/manage",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_admin_pages_testimonials_manage_AdminManageTestimonialsPage()
        }
        ctx.router.register(
            "/projects",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_pages_projects_ProjectsPage()
        }
        ctx.router.register(
            "/services",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_pages_services_ServicesPage()
        }
        ctx.router.register(
            "/services/service",
        ) { pageCtx -> 
            _cbconnectit_portfolio_web_pages_services_service_ServicePage()
        }

        cbconnectit.portfolio.web.pages.initErrorPage(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("title-medium", cbconnectit.portfolio.web.components.TitleMediumStyle)
        ctx.theme.registerStyle("data-table", cbconnectit.portfolio.web.components.table.DataTableStyle)
        ctx.theme.registerStyle("title-large", cbconnectit.portfolio.web.components.TitleLargeStyle)
        ctx.theme.registerStyle("services-type-card", cbconnectit.portfolio.web.components.ServicesTypeCardStyle)
        ctx.theme.registerStyle("service-section", cbconnectit.portfolio.web.pages.sections.serviceSectionStyle)
        ctx.theme.registerStyle("project-description", cbconnectit.portfolio.web.pages.sections.ProjectDescriptionStyle)
        ctx.theme.registerStyle("project-name", cbconnectit.portfolio.web.pages.sections.ProjectNameStyle)
        ctx.theme.registerStyle("valid-feedback", com.materialkobweb.styles.validFeedbackStyle)
        ctx.theme.registerStyle("invalid-feedback", com.materialkobweb.styles.invalidFeedbackStyle)
        ctx.theme.registerStyle("button-size-xl", com.materialkobweb.extensions.ButtonSizeXL)
        ctx.theme.registerStyle("navigation-item", com.materialkobweb.components.sections.NavigationItemStyle)
        ctx.theme.registerStyle("checked-input", com.materialkobweb.components.widgets.CheckedInputStyle)
        ctx.theme.registerStyle("ds-external-link", com.materialkobweb.components.widgets.DsExternalLinkStyle)
        ctx.theme.registerStyle("ds-card", com.materialkobweb.components.widgets.DsCardStyle)
        ctx.theme.registerStyle("multi-select", com.materialkobweb.components.widgets.MultiSelectStyle)
        ctx.theme.registerStyle("multi-select-defaults_size", com.materialkobweb.components.widgets.MultiSelectDefaults.Size)
        ctx.theme.registerStyle("multi-select-size_xs", com.materialkobweb.components.widgets.MultiSelectSize.Companion.XS)
        ctx.theme.registerStyle("multi-select-size_sm", com.materialkobweb.components.widgets.MultiSelectSize.Companion.SM)
        ctx.theme.registerStyle("multi-select-size_md", com.materialkobweb.components.widgets.MultiSelectSize.Companion.MD)
        ctx.theme.registerStyle("multi-select-size_lg", com.materialkobweb.components.widgets.MultiSelectSize.Companion.LG)
        ctx.theme.registerStyle("silk-text-area", com.materialkobweb.components.widgets.TextAreaStyle)
        ctx.theme.registerStyle("button-link", com.materialkobweb.components.widgets.ButtonLinkStyle)
        ctx.theme.registerStyle("select", com.materialkobweb.components.widgets.SelectStyle)
        ctx.theme.registerStyle("valid-select", com.materialkobweb.components.widgets.validSelectStyle)
        ctx.theme.registerStyle("invalid-select", com.materialkobweb.components.widgets.invalidSelectStyle)
        ctx.theme.registerStyle("select-form-floating", com.materialkobweb.components.widgets.SelectFormFloating)
        ctx.theme.registerStyle("select-defaults_size", com.materialkobweb.components.widgets.SelectDefaults.Size)
        ctx.theme.registerStyle("select-size_xs", com.materialkobweb.components.widgets.SelectSize.Companion.XS)
        ctx.theme.registerStyle("select-size_sm", com.materialkobweb.components.widgets.SelectSize.Companion.SM)
        ctx.theme.registerStyle("select-size_md", com.materialkobweb.components.widgets.SelectSize.Companion.MD)
        ctx.theme.registerStyle("select-size_lg", com.materialkobweb.components.widgets.SelectSize.Companion.LG)
        ctx.theme.registerVariant("-elevated-button-style", com.materialkobweb.components.widgets.ElevatedButtonStyle
        )
        ctx.theme.registerVariant("-filled-button-style", com.materialkobweb.components.widgets.FilledButtonStyle
        )
        ctx.theme.registerVariant("-outlined-button-style", com.materialkobweb.components.widgets.OutlinedButtonStyle
        )
        ctx.theme.registerVariant("-filled-tonal-button-style", com.materialkobweb.components.widgets.FilledTonalButtonStyle
        )
        ctx.theme.registerVariant("-text-button-style", com.materialkobweb.components.widgets.TextButtonStyle
        )
        ctx.theme.registerVariant("-ds-card-clickable-style", com.materialkobweb.components.widgets.DsCardClickableStyle
        )
        ctx.theme.registerVariant("-outlined-multi-select-style", com.materialkobweb.components.widgets.OutlinedMultiSelectStyle
        )
        ctx.theme.registerVariant("-", com.materialkobweb.components.widgets.MultiSelectDefaults.Variant
        )
        ctx.theme.registerVariant("-outlined", com.materialkobweb.components.widgets.OutlinedTextAreaVariant
        )
        ctx.theme.registerVariant("-elevated", com.materialkobweb.components.widgets.ElevatedButtonLinkVariant
        )
        ctx.theme.registerVariant("-filled", com.materialkobweb.components.widgets.FilledButtonLinkVariant
        )
        ctx.theme.registerVariant("-outlined", com.materialkobweb.components.widgets.OutlinedButtonLinkVariant
        )
        ctx.theme.registerVariant("-filled-tonal", com.materialkobweb.components.widgets.FilledTonalButtonLinkVariant
        )
        ctx.theme.registerVariant("-text", com.materialkobweb.components.widgets.TextButtonLinkVariant
        )
        ctx.theme.registerVariant("-primary-text-button-link-style", com.materialkobweb.components.widgets.PrimaryTextButtonLinkStyle
        )
        ctx.theme.registerVariant("-outlined-select-style", com.materialkobweb.components.widgets.OutlinedSelectStyle
        )
        ctx.theme.registerVariant("-unstyled-select-style", com.materialkobweb.components.widgets.UnstyledSelectStyle
        )
        ctx.theme.registerVariant("-", com.materialkobweb.components.widgets.SelectDefaults.Variant
        )
        ctx.theme.registerVariant("-elevated-icon-button-style", com.materialkobweb.components.widgets.ElevatedIconButtonStyle
        )
        ctx.theme.registerVariant("-filled-icon-button-style", com.materialkobweb.components.widgets.FilledIconButtonStyle
        )
        ctx.theme.registerVariant("-outlined-icon-button-style", com.materialkobweb.components.widgets.OutlinedIconButtonStyle
        )
        ctx.theme.registerVariant("-filled-tonal-icon-button-style", com.materialkobweb.components.widgets.FilledTonalIconButtonStyle
        )
        ctx.theme.registerVariant("-icon-button-style", com.materialkobweb.components.widgets.IconButtonStyle
        )
        ctx.theme.registerKeyframes("slide-in", com.materialkobweb.components.toast.SlideIn)
        ctx.theme.registerKeyframes("slide-out", com.materialkobweb.components.toast.SlideOut)
        ctx.theme.registerKeyframes("rotation-key-frames", com.materialkobweb.components.widgets.rotationKeyFrames)
        cbconnectit.portfolio.web.updateTheme(ctx)
        com.materialkobweb.updateTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        cbconnectit.portfolio.web.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
